import { useDispatch, useSelector } from "react-redux";
import { printTradingDataThunk } from "../thunks/printTradingDataThunk";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { TradingData } from "../types";
import { setDownloadFetchState } from "../tradingDataSlice";

export const useTradingDataPrinter = (tradingData?: TradingData) => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		s => s.data.clearing.tradingData.downloadReportFetchState
	);
	const dispatch = useDispatch();

	const download = React.useCallback(() => {
			dispatch(printTradingDataThunk(tradingData));
	}, [dispatch,tradingData ]);

	const dispatchSetFetch = React.useCallback(() => {                   //  Ovo da prvo izađe customDialog box
		dispatch(setDownloadFetchState({ type: "started" }))
	},	[dispatch] );
	
	return [download, fetchState, dispatchSetFetch] as [typeof download, typeof fetchState, typeof dispatchSetFetch];
};
